import { Create, SimpleForm, TextInput } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';

const initialValues = {
  date: '2022-01-24',
  firstSessionStart: '08:00',
  lastSessionEnd: '19:30',
};

// TODO: write a time-input with 5 min steps
// check https://marmelab.com/react-admin/Inputs.html#writing-your-own-input-component
// or https://github.com/vascofg/react-admin-date-inputs

export const DateCreate = (props: unknown) => (
  <Create {...props} title={<CustomTitle />}>
    <SimpleForm redirect={false} defaultValues={initialValues}>
      <TextInput source="date" type="date" />
      <TextInput source="firstSessionStart" type="time" />
      <TextInput source="lastSessionEnd" type="time" />
    </SimpleForm>
  </Create>
);
